import React from 'react';
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';

export interface BoxProps extends MuiBoxProps {
  children?: React.ReactNode;

}

const Box = ({ children, ...rest }: BoxProps) => {
  return (
    <MuiBox {...rest}>
      {children}
    </MuiBox>
  );
};
export default Box;
